<template>
  <div class="centerx" tabindex="0">
    <!-- Pop up for based on address API -->
    <vs-popup
      classContent="refund-popup-content-wrapper"
      :active.sync="showRefundPopup"
      vs-lg="12"
      vs-md="12"
      v-if="showRefundPopup"
      @click="closePopup()"
      button-close-hidden
    >
      <header>
        <h1>Refund Details</h1>
        <button
          class="cancel"
          @click="cancelRefund()"
          v-if="
            selectedRefundGetter.status === REFUND_STATUS.NEW.value &&
            hasRightsToCancel
          "
        >
          Cancel this refund
        </button>
        <button
          class="email"
          @click="openEmailPopup()"
          v-if="selectedRefundGetter.status === REFUND_STATUS.NEW.value &&
            hasRightsToEmail
          "
        >
          Resend/Change email
        </button>
        <button @click="closePopup">X</button>
      </header>
      <dl class="refund-details">
        <div>
          <dt>Refund reference</dt>
          <dd>{{ selectedRefundGetter.payout_reference }}</dd>
        </div>
        <div>
          <dt>Recipient's Email</dt>
          <dd>{{ selectedRefundGetter.payee_email }}</dd>
        </div>
        <div>
          <dt>Refund Creation Date</dt>
          <dd>
            {{ formatToLocalDate(selectedRefundGetter.payout_date) }},
            {{ formatToLocalTime(selectedRefundGetter.payout_date) }}
          </dd>
        </div>
        <div>
          <dt>Operator</dt>
          <dd>
            {{ selectedRefundGetter.operator }}
          </dd>
        </div>
        <div>
          <dt>Refund current status</dt>
          <dd class="capitalized">{{ selectedRefundGetter.status }}</dd>
        </div>
        <div>
          <dt>Last modified</dt>
          <dd>
            {{ formatToLocalDate(selectedRefundGetter.status_date) }},
            {{ formatToLocalTime(selectedRefundGetter.status_date) }}
          </dd>
        </div>
        <div v-if="selectedRefundGetter.account_type !== 'custody'">
          <dt>Refunded Amount ({{ selectedRefundGetter.payout_currency }})</dt>
          <dd>{{ selectedRefundGetter.withdraw_amount }}</dd>
        </div>
        <div v-if="selectedRefundGetter.crypto_currency === 'CRYPTOCOM'">
          <!--Check if the wallet provider is under Crypto.com Pay: Format amount differently-->
          <dt>Refunded Amount ({{ payment_details.display_crypto_currency }} - {{ selectedRefundGetter.crypto_currency }})</dt>
          <dd>
            {{
              selectedRefundGetter.net_crypto_amount
                ? formatFiatPrice(selectedRefundGetter.net_crypto_amount)
                : '-'
            }}
          </dd>
        </div>
        <div v-else>
          <dt>Refunded Amount ({{ selectedRefundGetter.crypto_currency }})</dt>
          <dd>
            {{
              selectedRefundGetter.net_crypto_amount
                ? formatCryptoPrice(selectedRefundGetter.net_crypto_amount)
                : '-'
            }}
          </dd>
        </div>
        <div>
          <dt>Receiving Address</dt>
          <dd>
            {{
              selectedRefundGetter.crypto_address
                ? selectedRefundGetter.crypto_address
                : '-'
            }}
          </dd>
        </div>
        <div class="order-id">
          <dt>Order ID</dt>
          <dd>
            {{
              selectedRefundGetter.payee_order_id
                ? selectedRefundGetter.payee_order_id
                : '-'
            }}
          </dd>
        </div>
        <div class="remarks">
          <dt>Refund Remarks</dt>
          <dd>
            {{
              selectedRefundGetter.status_remarks
                ? selectedRefundGetter.status_remarks
                : '-'
            }}
          </dd>
        </div>
      </dl>

      <section class="payment-details">
        <h2>Payment details</h2>
        <dl v-if="payment_details">
          <div>
            <dt>Payment reference</dt>
            <dd>{{ selectedRefundGetter.payment_reference_number }}</dd>
          </div>
          <div>
            <dt>Payment date</dt>
            <dd>
              {{ formatToLocalDate(payment_details.last_receive_date) }},
              {{ formatToLocalTime(payment_details.last_receive_date) }}
            </dd>
          </div>
          <div>
            <dt>Payer's name</dt>
            <dd>{{ payment_details.payer.payer_name }}</dd>
          </div>
          <div>
            <dt>Payer's email</dt>
            <dd>{{ payment_details.payer.payer_email }}</dd>
          </div>
          <div>
            <dt>Receiving address</dt>
            <dd>{{ payment_details.crypto_address }}</dd>
          </div>
          <div>
            <dt>Fiat amount</dt>
            <dd>
              {{ payment_details.payment_amount
              }}{{ payment_details.payment_currency }}
            </dd>
          </div>
          <div>
            <dt>Crypto amount</dt>
            <dd>
              <p v-if="payment_details.crypto_currency === 'CRYPTOCOM'">
                -
              </p>
              <p v-else>
                {{ payment_details.net_crypto_amount
                }}{{ payment_details.display_crypto_currency }}
              </p>
            </dd>
          </div>
          <div>
            <dt>
              Total Fee
              <span class="tooltip">
                <img
                  src="../../assets/icons/help.svg"
                  alt="more info on fees"
                />
                <span class="tooltip-text">
                  <strong>GST inclusive if applicable</strong> (merchants
                  incorporated in Singapore)
                </span>
              </span>
            </dt>
            <dd>{{ getTotalFeeAmountPmt(payment_details) }}</dd>
          </div>
        </dl>
        <p v-if="!payment_details">Loading more details...</p>
      </section>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CRYPTO_REFUND_STATUS } from '../../constants';

export default {
  props: ['shouldDisplay'],
  data() {
    return {
      debugConsole: false,
      showTransactionDetails: false,
      showRefundDetails: false,
      showRefundPopup: this.shouldDisplay,
      payment_details: null,
      hasRightsToCancel: false,
      hasRightsToEmail: false,
      REFUND_STATUS: CRYPTO_REFUND_STATUS,
    };
  },
  mounted() {
    if (!this.transaction) {
      this.displayPopup = false;
    }
    window.addEventListener('keyup', this.closePopupEscKey); // Add 'keyup' event to the popup
    window.addEventListener('keyup', this.closePopupEscKeyAddress);
  },
  updated() {
    if (!this.showRefundPopup) {
      this.closePopup();
    }
  },
  computed: {
    ...mapGetters([
      'popupDisplayCounterGetter',
      'selectedAddressGetter',
      'selectedRefundGetter',
      'associatedPaymentGetter',
      'activeMerchantGetter',
      'currentActiveEntityAdminGetter',
    ]),

    displayCounter: function () {
      return this.popupDisplayCounterGetter;
    },
  },
  watch: {
    selectedRefundGetter(newValue) {
      this.showRefundPopup = this.shouldDisplay && Boolean(newValue);
      this.getRights();
    },
    shouldDisplay(newValue) {
      this.showRefundPopup = newValue;
      if (this.showRefundPopup) this.getRights();
    },
    associatedPaymentGetter(newValue) {
      newValue
        ? (this.payment_details = newValue)
        : (this.payment_details = null);
    },
    activeMerchantGetter(newValue) {
      if (this.debugConsole) console.log('User changed', newValue);
      this.getRights();
    },
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.closePopupEscKey); // Remove 'keyup' event to the popup
    window.removeEventListener('keyup', this.closePopupEscKeyAddress);
  },
  methods: {
    ...mapActions(['fetchMoreAddressInfoAction']),

    toggleTransactionDetails() {
      this.showTransactionDetails = !this.showTransactionDetails;
    },

    toggleRefundDetails() {
      this.showRefundDetails = !this.showRefundDetails;
    },

    cancelRefund() {
      if (this.debugConsole)
        console.log(
          'Cancelling refund',
          this.selectedRefundGetter.payout_reference
        );
      this.$emit('cancel-clicked');
    },

    openEmailPopup() {
      if (this.debugConsole) console.log('Opening email popup');
      this.$emit('email-clicked');
    },

    closePopup() {
      this.$emit('closing-refund-details-popup');
      this.showRefundPopup = false;
      this.$store.commit('UPDATE_SELECTED_REFUND', null);
    },
    closePopupEscKey(e) {
      //Press 'Esc' to close the popup
      if (e.keyCode === 27) {
        this.closePopup();
      }
    },
    closePopupEscKeyAddress(e) {
      //Press 'Esc' to close the popup for Address popup
      if (e.keyCode === 27) {
        this.closePopup();
      }
    },
    countDecimals(value) {
      if (Math.floor(value) === value) return 0;
      return value.toString().split('.')[1].length || 0;
    },
    getRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      this.hasRightsToCancel = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'W'
      );
      this.hasRightsToEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'R'
      );
    },
    getTotalFeeAmountPmt(pmt) {
      if (pmt.account_type === 'custody') {
        return this.formatAmount(
          this.formatCryptoPrice(pmt.crypto_amount_fee + pmt.vat_crypto_amount),
          pmt.crypto_currency
        );
      }
      return this.formatAmount(
        pmt.fiat_amount_fee + pmt.vat_fiat_amount,
        pmt.local_currency
      );
    },
  },
};
</script>

<style lang="scss">
.refund-popup-content-wrapper {
  padding: 24px 24px 24px 40px !important;

  header {
    display: flex;
    margin-bottom: 12px;
    button {
      height: 32px;
      width: 32px;
      border: none;
      border-radius: 10px;
      margin-left: auto;
      transition: ease-in-out 0.2s;
      &:hover {
        background-color: rgb(174, 174, 174);
        cursor: pointer;
      }

      &.cancel {
        width: auto;
        color: white;
        background-color: #ca2828;
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 24px;
        &:hover {
          background-color: #8c2222;
        }
      }

      &.email {
        width: auto;
        color: white;
        background-color: rgb(7, 85, 147);
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 12px;
        &:hover {
          cursor: pointer;
          background-color: rgb(5, 59, 102);
        }
      }
    }
  }

  dl {
    display: flex;
    flex-wrap: wrap;
    .capitalized {
      text-transform: capitalize;
    }

    & > div {
      width: 50%;
      margin-bottom: 16px;
      padding-right: 12px;
      min-width: 300px;
      max-width: 380px;

      dt {
        font-weight: 700;
        color: #505050;
        text-transform: capitalize;
        .tooltip {
          position: relative;
          img {
            position: relative;
            height: 16px;
            width: 16px;
            top: 3px;
          }
          .tooltip-text {
            text-align: center;
            visibility: hidden;
            position: absolute;
            background: #efefef;
            padding: 6px 4px;
            border-radius: 3px;
            font-size: 12px;
            max-width: 550px;
            min-width: 200px;
            white-space: normal;
            font-weight: normal;
            top: -16px;
          }

          &:hover {
            .tooltip-text {
              visibility: visible;
            }
          }
        }
      }
      dd {
        line-break: anywhere;
      }

      &.remarks {
        width: 100%;
      }
      &.order-id {
        width: 100%;
      }
    }
  }

  h2 {
    margin-bottom: 12px;
  }

  .payment-details {
    margin-top: 24px;
  }
}

.con-vs-popup .vs-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  min-width: auto;
  padding: 0;
  margin: 0;
  max-width: 800px;
  width: 800px;
  display: block;
  max-height: initial;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  -webkit-animation: none !important;
  animation: none !important;
}

.con-vs-popup .vs-popup > header.vs-popup--header {
  display: none;
}

@media screen and (max-width: 950px) {
  .con-vs-popup .vs-popup {
    max-width: 750px;
    width: 750px;
  }
}

@media screen and (max-width: 600px) {
  .con-vs-popup .vs-popup {
    max-width: 90vw;
    width: 90vw;
  }
}

/* CUSTOMISED SCROLLBAR */
/*===========================*/
.vs-popup--content::-webkit-scrollbar {
  width: 10px;
}

.vs-popup--content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/*===========================*/
.vs-button {
  margin: 0 5px;
}

.rotate90 {
  transition: all 0.1s ease-out;
  transform: rotate(90deg);
}
</style>
